// extracted by mini-css-extract-plugin
export var postHeading = "index-module--post-heading--SJ7n1";
export var postMeta = "index-module--post-meta--DQdsu";
export var excerpt = "index-module--excerpt--mJSpv";